import React, { useEffect, useState, useCallback, useMemo, } from 'react';
import _debounce from 'lodash.debounce';
import { useEventListener } from '../utils/useEventListener.js';
import { isBottomBarVisible, isNavigationBarCollapsed } from './breakpoints.js';
import { MediaQueryContext } from './MediaQueryContext.js';
export const MediaQueryProvider = function MediaQueryProvider({ children, }) {
    const [isNavigationCollapsed, setIsNavigationCollapsed] = useState(isNavigationBarCollapsed().matches);
    const [bottomBarVisible, setBottomBarVisible] = useState(isBottomBarVisible().matches);
    const handleResize = useCallback(_debounce(() => {
        setIsNavigationCollapsed(isNavigationBarCollapsed().matches);
        setBottomBarVisible(isBottomBarVisible().matches);
    }, 40, { trailing: true, leading: true, maxWait: 40 }), []);
    useEffect(() => {
        setIsNavigationCollapsed(isNavigationBarCollapsed().matches);
        setBottomBarVisible(isBottomBarVisible().matches);
    }, []);
    const context = useMemo(() => ({ isNavigationCollapsed, bottomBarVisible }), [isNavigationCollapsed, bottomBarVisible]);
    useEventListener('resize', handleResize);
    return (React.createElement(MediaQueryContext.Provider, { value: context }, children));
};
//# sourceMappingURL=MediaQueryProvider.js.map